// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__RE6sj","content":"LayoutSettings_content__2V-RF"};